import { NavLink } from 'react-router-dom'
import { useSelector } from 'react-redux'
import classes from './MainSidebar.module.css'
import companiesIcon from '../../../images/Arrow - Right Square.svg'
import updatesIcon from '../../../images/Nav-Reminders.svg'
import clientsIcon from '../../../images/Nav-Students.svg'
import versionsIcon from '../../../images/Nav-Features.svg'
import usersIcon from '../../../images/single user.svg'

const items = [
  { key: 'Connect', path: '/support/companies', icon: companiesIcon },
  { key: 'Updates', path: '/support/updates', icon: updatesIcon },
  { key: 'Clients', path: '/support/clients', icon: clientsIcon },
  { key: 'Versions', path: '/support/versions', icon: versionsIcon },
  { key: 'Users', path: '/support/users', icon: usersIcon }
]

const SupportSidebarNav = ({ onClose }: { onClose?: () => void }) => {
  const isAdmin = useSelector((state: { auth: { supportIsAdmin: boolean } }) => state.auth.supportIsAdmin)
  const canSelectCompany = useSelector((state: { auth: { supportCanSelectCompany: boolean } }) => state.auth.supportCanSelectCompany)
  const visible = items.filter((item) => {
    if (item.key === 'Users') return isAdmin
    if (item.key === 'Connect') return isAdmin || canSelectCompany
    return true
  })

  return (
    <>
      {visible.map((item) => (
        <li key={item.key} className={classes['main-sidebar__item']}>
          <NavLink
            to={item.path}
            onClick={onClose}
            className={(navData) => `${classes['main-sidebar__nav']} ${navData.isActive ? classes.active : ''}`}
          >
            <div className={classes['nav-icon-wrapper']}>
              <img className={classes['nav-icon']} src={item.icon} alt="" />
            </div>
            <label>{item.key}</label>
          </NavLink>
        </li>
      ))}
    </>
  )
}

export default SupportSidebarNav
